import * as React from 'react';
import gettext from '@sdk/lang/gettext';

import laborCostImage from '../../assets/images/premium-features/labor-cost.png';
import budgetingImage from '../../assets/images/premium-features/budgeting.png';
import overtimeImage from '../../assets/images/premium-features/overtime.png';
import laborPercentageImage from '../../assets/images/premium-features/labor-percentage.png';

import { PremiumFeaturePreviewRow } from './PremiumFeaturePreviewRow';

export const LaborCostFeaturePreview: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <>
      <PremiumFeaturePreviewRow
        image={laborCostImage}
        imageWidth={210}
        title={gettext('Optimize labor cost')}
        description={gettext(
          'Set wages per employee or position to see how much each shift you schedule is costing you. Forecast and optimize labor costs while scheduling to ensure you stay on budget.'
        )}
      />
      <PremiumFeaturePreviewRow
        image={budgetingImage}
        imageWidth={200}
        title={gettext('Stay on budget')}
        description={gettext(
          'Keep track of your labor budget and get alerted whenever you are about to hit the specified threshold. Adjust your schedules accordingly to produce substantial amount of savings.'
        )}
        reverse
      />
      <PremiumFeaturePreviewRow
        image={overtimeImage}
        imageWidth={245}
        title={gettext('Spot and avoid potential overtime')}
        description={gettext(
          'Get notified whenever you are about to schedule someone into overtime and make changes to the schedule before overtime costs become a problem.'
        )}
      />
      <PremiumFeaturePreviewRow
        image={laborPercentageImage}
        imageWidth={220}
        title={gettext('View labor as a % of sales')}
        description={gettext(
          'Ensure your budgets are met consistently by viewing labor as a percentage of sales. Upload projected sales and see whether you are exceeding your labor % target right when you schedule.'
        )}
        reverse
      />
    </>
  );
};
